import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Slider_2_Cabs() {

    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobile, setIsMobile] = useState(false); // Track screen width
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: screenWidth <= 320 ? 2 : 4, // Show 2 slides for mobile
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 320, // Mobile screens
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // Mobile screens
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024, // Tablet screens
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };

  
useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
  
    window.addEventListener("resize", handleResize);
  
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  const getDynamicClass = () => {
    if (screenWidth <= 480) {
      return "swipper-cabs-small";
    } else if (screenWidth <= 768) {
      return "swipper-cabs-medium";
    } else if (screenWidth <= 1024) {
      return "swipper-cabs-large";
    } else {
      return "swipper-cabs-default";
    }
  };

  // Handle scroll event
  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    setIsScrolled(scrollTop > 50);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="popular-state pt-5 holidays-left">
    <div className="container">
        <div className="title">
            <h3><span>Flexible </span> Hourly Car Rentals in India</h3>
            <p className="mb-4">Rent a car by the hour for convenient and affordable travel within major Indian cities. Enjoy the freedom to explore at your own pace.</p>
        </div>
        <div
          className={`cabs_slider customer-logos slider airport-transfer-slide-sec slider-cabs ${isScrolled ? "slide" : ""} ${getDynamicClass()}`}
        >
        {/* <div className={`customer-logos slider airport-transfer-slide-sec ${isScrolled ? "slide" : ""}`}> */}
        {/* <div className="customer-logos slider airport-transfer-slide-sec"> */}
        <Slider {...settings}>
            <div className="slide" style={{ width:'155px'}}>
                <div className="post-item">
                    <div className="post__img">
                        <a href="/holidays-list">
                            <img src="https://www.easemytrip.com/cabs/img/delhi-car.png" alt="post image" loading="lazy"/>
                        </a>
                    </div>

                    <div className="post__body">
                        <div className="post__meta-cat">
                            <div className="ttl-text-book">
                                <div className="ttl-text d-flex justify-content-space-between gap-3">
                                    <div className="left">
                                        <h5>Hyderabad</h5>
                                        <p>Andhra Pradesh, India</p>
                                    </div>
                                    <div className="right">
                                        <div className="img">
                                            <img src="https://www.easemytrip.com/cabs/img/copy-clock.svg" alt="copy-clock"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="book-wrap">
                                    <a href="https://www.easemytrip.com/cabs/car-rental-delhi/">
                                        <div className="book-list d-flex justify-content-space-between align-items-center">
                                            <div className="book">
                                                <p>From <span>₹940</span></p>
                                            </div>
                                            <div className="book-link">
                                                <span className="book" onclick="$(window).scrollTop(0);">Book <img src="https://www.easemytrip.com/cabs/img/arrow-yellow.png" alt="red-arrow"/></span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div className="slide" style={{ width:'155px'}}>

                <div className="post-item">
                    <div className="post__img">
                        <a href="/holidays-list">
                            <img src="https://www.easemytrip.com/cabs/img/Bangaluru-car.png" alt="post image" loading="lazy"/>
                        </a>
                    </div>

                    <div className="post__body">
                        <div className="post__meta-cat">
                            <div className="ttl-text-book">
                                <div className="ttl-text d-flex justify-content-space-between gap-3">
                                    <div className="left">
                                        <h5>Hyderabad</h5>
                                        <p>Andhra Pradesh, India</p>
                                    </div>
                                    <div className="right">
                                        <div className="img">
                                            <img src="https://www.easemytrip.com/cabs/img/copy-clock.svg" alt="copy-clock"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="book-wrap">
                                    <a href="https://www.easemytrip.com/cabs/car-rental-delhi/">
                                        <div className="book-list d-flex justify-content-space-between align-items-center">
                                            <div className="book">
                                                <p>From <span>₹940</span></p>
                                            </div>
                                            <div className="book-link">
                                                <span className="book" onclick="$(window).scrollTop(0);">Book <img src="https://www.easemytrip.com/cabs/img/arrow-yellow.png" alt="red-arrow"/></span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div className="slide" style={{ width:'155px'}}>

                <div className="post-item">
                    <div className="post__img">
                        <a href="/holidays-list">
                            <img src="https://www.easemytrip.com/cabs/img/Ahmedabad-car.png" alt="post image" loading="lazy"/>
                        </a>
                    </div>

                    <div className="post__body">
                        <div className="post__meta-cat">
                            <div className="ttl-text-book">
                                <div className="ttl-text d-flex justify-content-space-between gap-3">
                                    <div className="left">
                                        <h5>Hyderabad</h5>
                                        <p>Andhra Pradesh, India</p>
                                    </div>
                                    <div className="right">
                                        <div className="img">
                                            <img src="https://www.easemytrip.com/cabs/img/copy-clock.svg" alt="copy-clock"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="book-wrap">
                                    <a href="https://www.easemytrip.com/cabs/car-rental-delhi/">
                                        <div className="book-list d-flex justify-content-space-between align-items-center">
                                            <div className="book">
                                                <p>From <span>₹940</span></p>
                                            </div>
                                            <div className="book-link">
                                                <span className="book" onclick="$(window).scrollTop(0);">Book <img src="https://www.easemytrip.com/cabs/img/arrow-yellow.png" alt="red-arrow"/></span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div className="slide" style={{ width:'155px'}}>

                <div className="post-item">
                    <div className="post__img">
                        <a href="/holidays-list">
                            <img src="https://www.easemytrip.com/cabs/img/jaipur.png" alt="post image" loading="lazy"/>
                        </a>
                    </div>

                    <div className="post__body">
                        <div className="post__meta-cat">
                            <div className="ttl-text-book">
                                <div className="ttl-text d-flex justify-content-space-between gap-3">
                                    <div className="left">
                                        <h5>Hyderabad</h5>
                                        <p>Andhra Pradesh, India</p>
                                    </div>
                                    <div className="right">
                                        <div className="img">
                                            <img src="https://www.easemytrip.com/cabs/img/copy-clock.svg" alt="copy-clock"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="book-wrap">
                                    <a href="https://www.easemytrip.com/cabs/car-rental-delhi/">
                                        <div className="book-list d-flex justify-content-space-between align-items-center">
                                            <div className="book">
                                                <p>From <span>₹940</span></p>
                                            </div>
                                            <div className="book-link">
                                                <span className="book" onclick="$(window).scrollTop(0);">Book <img src="https://www.easemytrip.com/cabs/img/arrow-yellow.png" alt="red-arrow"/></span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div className="slide" style={{ width:'155px'}}>

            <div className="post-item">
                <div className="post__img">
                    <a href="/holidays-list">
                        <img src="https://www.easemytrip.com/cabs/img/delhi-car.png" alt="post image" loading="lazy"/>
                    </a>
                </div>

                <div className="post__body">
                    <div className="post__meta-cat">
                        <div className="ttl-text-book">
                            <div className="ttl-text d-flex justify-content-space-between gap-3">
                                <div className="left">
                                    <h5>Hyderabad</h5>
                                    <p>Andhra Pradesh, India</p>
                                </div>
                                <div className="right">
                                    <div className="img">
                                        <img src="https://www.easemytrip.com/cabs/img/copy-clock.svg" alt="copy-clock"/>
                                    </div>
                                </div>
                            </div>
                            <div className="book-wrap">
                                <a href="https://www.easemytrip.com/cabs/car-rental-delhi/">
                                    <div className="book-list d-flex justify-content-space-between align-items-center">
                                        <div className="book">
                                            <p>From <span>₹940</span></p>
                                        </div>
                                        <div className="book-link">
                                            <span className="book" onclick="$(window).scrollTop(0);">Book <img src="https://www.easemytrip.com/cabs/img/arrow-yellow.png" alt="red-arrow"/></span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            </div>

            <div className="slide" style={{ width:'155px'}}>

                <div className="post-item">
                    <div className="post__img">
                        <a href="/holidays-list">
                            <img src="https://www.easemytrip.com/cabs/img/varansi.png" alt="post image" loading="lazy"/>
                        </a>
                    </div>

                    <div className="post__body">
                        <div className="post__meta-cat">
                            <div className="ttl-text-book">
                                <div className="ttl-text d-flex justify-content-space-between gap-3">
                                    <div className="left">
                                        <h5>Hyderabad</h5>
                                        <p>Andhra Pradesh, India</p>
                                    </div>
                                    <div className="right">
                                        <div className="img">
                                            <img src="https://www.easemytrip.com/cabs/img/copy-clock.svg" alt="copy-clock"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="book-wrap">
                                    <a href="https://www.easemytrip.com/cabs/car-rental-delhi/">
                                        <div className="book-list d-flex justify-content-space-between align-items-center">
                                            <div className="book">
                                                <p>From <span>₹940</span></p>
                                            </div>
                                            <div className="book-link">
                                                <span className="book" onclick="$(window).scrollTop(0);">Book <img src="https://www.easemytrip.com/cabs/img/arrow-yellow.png" alt="red-arrow"/></span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </Slider>
        </div>

    </div>
</section>
  );
}

export default Slider_2_Cabs;
